import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { tap, finalize } from 'rxjs/operators';
import { RestActivityHandlerService } from '../rest-activity-handler.service';
import { RestErrorHandlerService } from '../rest-error-handler.service';
import type { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import type { Observable } from 'rxjs';

export const restActivityInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const restActivityHandlerService = inject(RestActivityHandlerService);
  const restErrorHandlerService = inject(RestErrorHandlerService);
  restActivityHandlerService.start();
  return next(req).pipe(
    finalize((): void => restActivityHandlerService.complete()),
    tap({
      error(error: unknown): void {
        if (error instanceof HttpErrorResponse) {
          restErrorHandlerService.error(error);
        }
      }
    })
  );
};
